import { getProductsGroupedByCategories } from '@/services/api';

export default {
  namespaced: true,

  state: {
    rooms: [],
  },

  actions: {
    async fetchProducts({ commit, rootGetters }) {
      commit('clearRooms');
      let rooms = rootGetters['build/getRooms'];

      if (rooms.length === 0) {
        rooms = [rootGetters['build/getActiveRoom']];
      }

      const fetchProductData = async (room) => {
        const lineId = room.line.id;
        const productIds = room.products.map((product) => product.id);

        const { data } = await getProductsGroupedByCategories(
          lineId,
          productIds
        );

        commit('setProducts', {
          id: room.id,
          products: data.products,
        });
      };

      await Promise.all(rooms.map(fetchProductData));
    },
  },

  mutations: {
    setProducts(state, payload) {
      state.rooms.push(payload);
    },
    clearRooms(state) {
      state.rooms = [];
    },
    removeProductById(state, payload) {
      const room = state.rooms.find((room) => room.id === payload.roomId);

      const index = room.products.findIndex(
        (product) => product.id === payload.productId
      );

      room.products.splice(index, 1);
    },
  },

  getters: {
    getRoomOrders(state, getters, rootState, rootGetters) {
      const orders = [];
      let rooms = rootGetters['build/getRooms'];

      if (rooms.length === 0) {
        rooms = [rootGetters['build/getActiveRoom']];
      }

      rooms.forEach((room) => {
        const order = {
          room: room,
          productsWithAmount: [],
        };

        const buildProductAmountMap = room.products.reduce(
          (map, buildProduct) => {
            map[buildProduct.id] = buildProduct.amount;
            return map;
          },
          {}
        );

        const enrichedProducts =
          state.rooms.find((enrichedRoom) => enrichedRoom.id === room.id)
            ?.products || [];

        for (const product of enrichedProducts) {
          order.productsWithAmount.push({
            ...product,
            amount: buildProductAmountMap[product.category_product_id] || 0,
          });
        }

        orders.push(order);
      });

      return orders;
    },
  },
};
